import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, WithCircleChartsStepData } from '@packages/shared/core/quiz/entities';

type WithCircleChartsStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const WithCircleChartsStep = ({ id, renderQuizScreen }: WithCircleChartsStepProps) => {
  const logger = useLogger();

  const { back, next, stepData } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        ...(stepData as WithCircleChartsStepData),
      })}
    </>
  );
};

export default WithCircleChartsStep;
